const BulmaAutocomplete = r => require.ensure([], () => r(require('./BulmaAutocomplete.vue')), 'shared')

export { BulmaAutocomplete }
